module.exports = __webpack_public_path__ + "img/Villa_Borna_23.0a98ce13.jpg";